import React from 'react';
import { Modal, Button } from '@mui/material';
import { Close, Check, ArrowForward } from '@mui/icons-material';

interface TaskSuccessModalProps {
  open: boolean;
  createdTask: any | null;
  onClose: () => void;
}

const TaskSuccessModal: React.FC<TaskSuccessModalProps> = ({
  open,
  createdTask,
  onClose,
}) => {
  if (!createdTask) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <div className="flex justify-center items-center w-full h-full">
        <div className="w-[500px] bg-white border p-6 max-h-[90vh] overflow-y-auto relative">
          <Close
            className="absolute top-4 right-4 cursor-pointer hover:text-slate-400"
            onClick={onClose}
          />
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Check className="text-green-600 text-2xl" />
            </div>
            <h1 className="text-xl font-bold text-green-700 mb-2">Movement Task Created Successfully!</h1>
            <p className="text-gray-600">The trailer has been scheduled to move to the dock door.</p>
          </div>
          
          {/* Task Details */}
          <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
            <h2 className="font-semibold mb-3 text-gray-800">Task Details</h2>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="font-medium text-gray-600">Task ID:</span>
                <span className="text-gray-800 font-mono text-sm">{createdTask.uuid}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium text-gray-600">Task Type:</span>
                <span className="text-gray-800">{createdTask.task_type?.type || 'Movement Task'}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium text-gray-600">Status:</span>
                <span className="text-gray-800">{createdTask.task_status?.status || 'Created'}</span>
              </div>
              {createdTask.from_location && (
                <div className="flex justify-between">
                  <span className="font-medium text-gray-600">From:</span>
                  <span className="text-gray-800">{createdTask.from_location}</span>
                </div>
              )}
              {createdTask.to_location && (
                <div className="flex justify-between">
                  <span className="font-medium text-gray-600">To:</span>
                  <span className="text-gray-800">{createdTask.to_location}</span>
                </div>
              )}
              {createdTask.trailer?.trailer_number && (
                <div className="flex justify-between">
                  <span className="font-medium text-gray-600">Trailer:</span>
                  <span className="text-gray-800">{createdTask.trailer.trailer_number}</span>
                </div>
              )}
            </div>
          </div>
          
          {/* Action Buttons */}
          <div className="flex justify-between pt-4 border-t">
            <Button onClick={onClose}>
              Close
            </Button>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => {
                window.open(`/tasks/${createdTask.uuid}`, '_blank');
              }}
              startIcon={<ArrowForward />}
            >
              View Task Details
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TaskSuccessModal;

